<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "App",
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true, //控制视图是否显示的变量
    };
  },
  computed: {
    ...mapState("language", ["language"]),
  },
  watch: {
    // 监听语言的变化
    language(newVal, oldVal) {
      if (newVal != oldVal) {
        // 刷新页面
        this.reload();
      }
    },
  },
  methods: {
    reload() {
      // 先关闭
      this.isRouterAlive = false;
      this.$nextTick(function () {
        // 再打开
        this.isRouterAlive = true;
      });
    },
  },
};
</script>
